import { Page, PageTitleWithBack } from '../../../components';
import { BulkStandardFeaturesForm } from './bulk-standard-features-form';

export const BulkStandardFeaturesPage = () => {
  return (
    <>
      <Page title="Bulk Standard Featues">
        <PageTitleWithBack backText="Back to Admin" backUrl={'/admin'} title="Bulk Standard Features" />
        <BulkStandardFeaturesForm />
      </Page>
    </>
  );
};
